import { createContext, ReactNode, useContext, useMemo, useState } from "react";

interface OnboardingTransitionContextValue {
  isExiting: boolean;
  setIsExiting: (isExiting: boolean) => void;
}

const OnboardingTransitionContext = createContext<OnboardingTransitionContextValue>({
  isExiting: false,
  setIsExiting: () => {},
});

export const OnboardingTransitionProvider = ({ children }: { children: ReactNode }) => {
  const [isExiting, setIsExiting] = useState(false);
  const value = useMemo(() => ({ isExiting, setIsExiting }), [isExiting]);

  return (
    <OnboardingTransitionContext.Provider value={value}>
      {children}
    </OnboardingTransitionContext.Provider>
  );
};

export const useOnboardingTransition = () => useContext(OnboardingTransitionContext);
